/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * OnboardingPath identifies the installation method used for onboarding.
 * @export
 * @enum {string}
 */

export const ExternalclusterV1OnboardingPath = {
    UNSPECIFIED: 'ONBOARDING_PATH_UNSPECIFIED',
    SCRIPT: 'ONBOARDING_PATH_SCRIPT',
    HELM: 'ONBOARDING_PATH_HELM',
    CASTCTL: 'ONBOARDING_PATH_CASTCTL'
} as const;

export type ExternalclusterV1OnboardingPath = typeof ExternalclusterV1OnboardingPath[keyof typeof ExternalclusterV1OnboardingPath];



